module.exports = __webpack_public_path__ + "img/Khalti_Logo_Color.8f67bbd7.png";